// Export the Component Definition for use in Contentful Studio
export {YourSchoolContentfulComponentDefinition} from './YourSchoolContentfulDefinition';
export {default} from './YourSchool';
